var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.21,61.707l-7.063-7.063c3.345-2.782,5.372-5.092,5.583-5.335L79.861,48l-1.132-1.309 C78.171,46.046,64.857,30.879,48,30.879c-16.857,0-30.171,15.167-30.73,15.812L16.138,48l1.132,1.309 c0.211,0.243,2.238,2.553,5.583,5.335l-7.063,7.063c-0.781,0.781-0.781,2.047,0,2.828c0.39,0.391,0.902,0.586,1.414,0.586 s1.024-0.195,1.414-0.586l7.424-7.424c2.079,1.496,4.464,2.993,7.094,4.284l-4.06,9.444c-0.436,1.015,0.033,2.191,1.047,2.627 c0.258,0.111,0.525,0.164,0.789,0.164c0.775,0,1.513-0.454,1.838-1.211l4.057-9.438c2.869,1.074,5.954,1.834,9.191,2.061v9.034 c0,1.104,0.896,2,2,2s2-0.896,2-2v-9.034c3.237-0.228,6.322-0.987,9.191-2.061l4.057,9.438c0.326,0.757,1.063,1.211,1.839,1.211 c0.264,0,0.531-0.053,0.789-0.163c1.015-0.437,1.483-1.613,1.048-2.628l-4.06-9.445c2.63-1.291,5.015-2.788,7.093-4.284 l7.424,7.424c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586C80.991,63.754,80.991,62.488,80.21,61.707z M48,34.879 c12.281,0,22.93,9.565,26.464,13.121C70.93,51.556,60.281,61.121,48,61.121c-12.28,0-22.93-9.564-26.464-13.121 C25.07,44.444,35.72,34.879,48,34.879z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.b3405b834ce2a13a2f8a2ec03eb97f52.svg";
export { ForwardRef as ReactComponent };